import apiService from "./axiosInstance";

/*
 * POST - Create Customer, accepts customer data object
 */
export const createCustomerService = (data: object, testMode = false) => {
  // Test mode to simulate a 502 error for deadman login testing
  if (testMode) {
    const error: any = new Error("Simulated 502 Bad Gateway error");
    error.status = 502;
    error.response = {
      status: 502,
      message: "Simulated 502 Bad Gateway error for testing deadman login",
    };
    return Promise.reject(error);
  }
  return apiService.post("/customers", data);
};

/*
 * POST - Check preflight username availability
 */
export const preflightUsernameService = (data: object) => {
  return apiService.post("/customers/verify/username", data);
};

/*
 * POST - Discount Code Verification, accets discount code, and product code
 */
export const promoCodeService = (data: object) => {
  return apiService.post("/customers/verify/discount", data);
};

/*
 * POST - Generate Login Credentials based on credentialType
 * Credential Types: mccs, bwpromo, datacapture, subscriber, roamer
 * mccs: it returns username and password; requires ap_mac
 * bwpromo: it returns BWPROMO string; requires venue_id, mac
 * datacapture: it returns BWPROMO string; requires venue_id, ap_mac, mac, FirstName, Email
 * subscriber: it returns object with credentials and booleans for showing modal; requires user, username, password, page title
 * roamer: it returns object with credentials and booleans for showing modal; requires user, username, password, page title
 * Use for Lounge, Private Services, Retail
 */
export const getLoginCredentials = (data: object, credentialType: string) => {
  return apiService.post(`/credentials/${credentialType}`, data);
};

/*
 * POST - Generate Smartzone Login Credentials
 * Requires username, password, ip, mac
 */
export const smartZoneLoginWithCredentials = (data: object) => {
  return apiService.post("/gateway/login/smartzone", data);
};

/*
 * PUT - Generate Subscriber Login Credentials
 * Requires customer_id, effective_datetime, status
 */
export const statusUpdateAccount = (data: object) => {
  return apiService.put("/customers/status", data);
};
/*
 * PUT - Update Customer Account
 * Requires customer ID
 */
export const updateCustomer = (data: object) => {
  return apiService.put("/customers", data);
};

/*
 * POST - Returns Device List from username/password
 */

export const getDeviceList = (data: object) => {
  return apiService.post("/devices/list", data);
};

/*
 * PUT - Swap User Device MAC Address
 */
export const updateDeviceList = (deviceId: string, deviceMac: object) => {
  return apiService.put(`/devices/${deviceId}`, deviceMac);
};

/*
 * POST - Add Users Device to User and logs them in to the Network
 */
export const addDeviceList = (data: object) => {
  return apiService.post("/devices", data);
};

/**
 * GET - Get Venue Maps;
 * @param data 
 * @returns 
 */

export const getVenueMaps = (query?: string) => {
  const path = query !== undefined? `/venuemaps?${query}` : `/venuemaps`; 
  return apiService.get(path);
}
/*
 * POST - Log to Event API
 */
export const eventApiLogger = (data: object) => {
  return apiService.post("/log/event", data);
};

export const lookupGSID = () => {
  return apiService.get("/session/gsid");
}

export const initSession = () => {
  return apiService.get("/session/init");
}
